export enum ConsumerMapRoutes {
  MAP = '',
  PLANS = 'plans',
  FAVORITES = 'favorites',
  SHARED = 'shared-with-me',
}
